const getEnvConfig = () => ({
  API_BASE_URL: import.meta.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  WS_BASE_URL: import.meta.env.REACT_APP_WS_BASE_URL || 'ws://localhost:8000',
  MODE: import.meta.env.REACT_APP_ENV || 'development',
});

export const { API_BASE_URL, WS_BASE_URL, MODE } = getEnvConfig();

export const isProduction = MODE === 'production';
export const isDevelopment = MODE === 'development';
export const isTest = MODE === 'test'; 